var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stars"},_vm._l((5),function(i){return _c('div',{staticClass:"star"},[(_vm.getStarType(i) === _vm.types.Split)?_c('inline-svg',{attrs:{"src":_vm.icons.splittedStarIcon}}):_c('inline-svg',{attrs:{"src":_vm.icons.starIcon,"fill":_vm.getColor(_vm.getStarType(i))}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }